import axios from 'axios'
import { CADASTRAR_PESSOA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function cadastrarPessoa (pessoa) {
  const url = `${URL}/pessoas/cadastrar`;
  return dispatch => axios.post(url, pessoa, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: CADASTRAR_PESSOA,
        payload: response
      })
  );
}
